import ApiGatewayFunction from "../../UserConfigs/ApiGatewayFunction.js";

/**
 * Approves a draft asset - a direct, synchronous status flip, no build or
 * validation involved. Deliberately does not go through startExportJob's
 * async job/Node-worker machinery: that exists specifically to run the
 * (expensive) buildEmissions render, which approval no longer needs at all.
 */
export async function approveAsset(appConfig, { brandId, assetId }, setIsLoading, setApiResponse) {
  const payload = {
    request_type: "studio/create_asset",
    request_sub_type: "set_asset_status",
    client_id: appConfig.clientId,
    brand_id: brandId,
    asset_id: assetId,
    status: "approved",
  };

  const response = await ApiGatewayFunction(
    payload,
    appConfig.patternAPI,
    appConfig.support_key,
    appConfig.support_id,
    setIsLoading,
    setApiResponse,
    appConfig.testingState
  );

  const asset = response?.data?.asset;
  if (!asset) {
    throw new Error(response?.data?.error || "Couldn't approve this asset");
  }
  return asset;
}